<template>
  <div class="component-feature-card">
    <div class="warning-icon" v-if="warning">
      <bp-tooltip :text="warning">
        <bp-icon
          size="20"
          class="text-alert-300"
          icon="fa fa-circle-exclamation"
        />
      </bp-tooltip>
    </div>
    <div class="feature-card">
      <bp-icon size="26" class="feature-icon" :style="{ color }" :icon="icon" />

      <div>
        <h4 class="mb-3 text-neutral-700">{{ title }}</h4>
        <span class="functional-1 text-neutral-400">
          {{ subtitle }}
        </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: String,
    subtitle: String,
    icon: String,
    color: String,
    warning: String
  }
};
</script>
<style lang="scss">
.component-feature-card {
  height: 100%;
  padding-top: 16px;
  position: relative;
  .warning-icon {
    top: 16px;
    position: absolute;
    transform: translateY(-50%);
    background: linear-gradient(
      0deg,
      #fcfcfd 0%,
      rgba(250, 251, 252, 0.9) 100%
    );
    right: 8px;
    z-index: 10;
    border-radius: 42px;
  }

  .feature-card {
    gap: 12px;
    height: 100%;
    display: flex;
    padding: 16px;
    border-radius: var(--4-8, 4px);
    border: 1px solid var(--Semantic-Neutral-100, #d7d7d7);
    background: var(--Surface-Cumulative-plus4, rgba(255, 255, 255, 0.16));

    transition: 0.2s all;

    &:hover {
      border: 1px solid var(--Semantic-Neutral-076, rgba(215, 215, 215, 0.76));
      background: var(--Surface-Cumulative-plus8, rgba(255, 255, 255, 0.32));
      box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.12);
    }
    &:active {
      border: 1px solid var(--Semantic-Primary-Accent-300, #a967ff);
      background: var(--Surface-Cumulative-plus4, rgba(255, 255, 255, 0.16));
      box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.12);
    }

    .feature-icon {
      color: var(--color);
    }
  }
}

button:has(.component-feature-card) {
  padding: 0;
  width: 100%;
  height: 100%;
  border: none;
  text-align: left;
  background-color: unset;
}
</style>
